import { render } from "./HariLibur.vue?vue&type=template&id=2e887227"
import script from "./HariLibur.vue?vue&type=script&lang=js"
export * from "./HariLibur.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__